import { Directive, Input, Output, HostListener, ElementRef, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * @whatItDoes Adds a listener to an element to listen for char 10 or 13.
 *
 * @howToUse
 * <input type="text" wl-on-enter-press (onEnterPess)="doThisThingWhenUserPressesEnter($event)"/>
 */
@Directive({
  selector: '[wl-on-enter-press]',
  standalone: false
})
export class WlOnEnterPressDirective {
  /*
   * emitted when enter pressed
   */
  @Output() public onEnterPess: EventEmitter<KeyboardEvent> = new EventEmitter<KeyboardEvent>();

  /**
   * bind the host's keydown event
   */
  @HostListener('keydown', ['$event'])
  public handleKeyPress(event: KeyboardEvent): void {
    if (event.key.toLowerCase() == 'enter') this.onEnterPess.emit(event);
  }
}
